// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .p-paginator .p-dropdown {
  display: none;
}
::ng-deep :focus {
  outline: 0 !important;
  box-shadow: none !important;
}
::ng-deep div.content-layout {
  display: flex;
  position: relative;
  justify-content: center;
  flex-wrap: wrap;
  flex-direction: row;
  flex: 1;
}
::ng-deep div.background {
  position: relative;
  width: 100%;
}
::ng-deep div.background:before {
  content: "";
  position: absolute;
  background-image: url("/assets/images/rooftop-solar-grid.jpeg");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: left top;
  width: 100%;
  height: 100%;
  min-height: 475px;
  z-index: 1;
}
::ng-deep ul.disc {
  list-style-type: disc;
  margin-bottom: 1rem;
}
::ng-deep ul.disc li {
  margin-left: 2rem;
  margin-bottom: 0.5rem;
}
::ng-deep :focus {
  outline: 0 !important;
}
::ng-deep #product-id {
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  flex: 1;
}
::ng-deep #product-id #left-or-top {
  display: flex;
  flex: 1;
  padding-right: 1rem;
  overflow: hidden;
}
::ng-deep #product-id #right-or-bottom {
  display: flex;
  padding-left: 1rem;
  overflow: hidden;
  flex: 1;
  flex-direction: column;
}
::ng-deep #product-id #right-or-bottom a.category {
  color: var(--accent);
}
::ng-deep #product-id #right-or-bottom p.shallow {
  margin: 0 0 0.5rem;
}
::ng-deep #product-container table {
  margin-bottom: 1.25rem;
  width: 100% !important;
}
::ng-deep #product-container table td, ::ng-deep #product-container table th {
  padding: 0.33rem 0.5rem;
  border-bottom: 1px solid var(--gray-4);
  font-size: 1em;
}
::ng-deep div#overview-div p {
  margin-bottom: 1rem;
}
::ng-deep div#overview-div h3 {
  font-size: 20px;
  font-weight: 400;
  color: var(--dark-1);
}
::ng-deep div#overview-div h4 {
  font-size: 16px;
  font-weight: 600;
  color: var(--dark-1);
}
::ng-deep div#overview-div div ul {
  list-style-type: none;
  margin-left: 2rem !important;
}
::ng-deep div#overview-div div ul li {
  margin-bottom: 1rem;
}
::ng-deep div.product-specs-div .p-datatable .p-datatable-thead tr th {
  background-color: black;
  color: whitesmoke;
}
::ng-deep div.product-docs-div .p-datatable .p-datatable-thead tr th {
  background-color: #f5f5f5;
}
::ng-deep div.product-docs-div .p-datatable .p-datatable-tbody tr > td.right {
  text-align: right !important;
}
::ng-deep p-galleria {
  display: block;
  width: 100%;
  height: 100%;
  border: 1px solid var(--gray-3);
  border-radius: 1rem;
  overflow: hidden;
}
::ng-deep p-galleria.fullscreen {
  display: flex;
  flex-direction: column;
}
::ng-deep p-galleria.fullscreen .p-galleria-content {
  flex-grow: 1;
  justify-content: center;
}
::ng-deep p-galleria p-galleriacontent {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
  max-width: 475px;
  max-height: 580px;
  margin: 1rem auto;
}
::ng-deep p-galleria p-galleriacontent .p-galleria-thumbnail-wrapper {
  width: 100%;
  background: #fff;
  height: 100px;
  overflow: hidden;
}
::ng-deep p-galleria p-galleriacontent .p-galleria-thumbnail-wrapper .p-galleria-thumbnail-container {
  background: #fff;
  height: 100px;
}
::ng-deep p-galleria p-galleriacontent .p-galleria-thumbnail-wrapper .p-galleria-thumbnail-container .p-galleria-thumbnail-next,
::ng-deep p-galleria p-galleriacontent .p-galleria-thumbnail-wrapper .p-galleria-thumbnail-container .p-galleria-thumbnail-prev {
  color: var(--primary-color) !important;
}
::ng-deep p-galleria p-galleriacontent .p-galleria-thumbnail-wrapper .p-galleria-thumbnail-container .p-galleria-thumbnail-next.p-disabled,
::ng-deep p-galleria p-galleriacontent .p-galleria-thumbnail-wrapper .p-galleria-thumbnail-container .p-galleria-thumbnail-prev.p-disabled {
  opacity: 0.25;
}
::ng-deep p-galleria p-galleriacontent .p-galleria-thumbnail-wrapper .p-galleria-thumbnail-container .p-galleria-thumbnail-items-container .p-galleria-thumbnail-items {
  height: 100%;
}
::ng-deep p-galleria p-galleriacontent .p-galleria-thumbnail-wrapper .p-galleria-thumbnail-container .p-galleria-thumbnail-items-container .p-galleria-thumbnail-items .p-galleria-thumbnail-item {
  flex: 1 0 20%;
}
::ng-deep p-galleria p-galleriacontent .p-galleria-thumbnail-wrapper .p-galleria-thumbnail-container .p-galleria-thumbnail-items-container .p-galleria-thumbnail-items .p-galleria-thumbnail-item .p-galleria-thumbnail-item-content {
  margin-right: 0.25rem;
  border: 1px solid gray;
  max-width: 68.2px;
}
::ng-deep p-galleria p-galleriathumbnails {
  position: relative;
  height: auto;
  min-height: 100px;
}
::ng-deep p-galleria .p-galleria-thumbnail-items-container {
  width: 100%;
}
::ng-deep p-galleria .custom-galleria-footer {
  display: flex;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.9);
  color: #ffffff;
}
::ng-deep p-galleria .custom-galleria-footer > button {
  background-color: transparent;
  color: #ffffff;
  border: 0 none;
  border-radius: 0;
  margin: 0.2rem 0;
}
::ng-deep p-galleria .custom-galleria-footer > button.fullscreen-button {
  margin-left: auto;
}
::ng-deep p-galleria .custom-galleria-footer > button:hover {
  background-color: rgba(255, 255, 255, 0.1);
}
::ng-deep p-galleria .title-container > span {
  font-size: 0.9rem;
  padding-left: 0.829rem;
}
::ng-deep p-galleria .title-container > span.title {
  font-weight: bold;
}
::ng-deep .product-collection .product-main-content table td {
  border-bottom: none;
}
::ng-deep .product-collection .product-main-content .grid-product-results {
  justify-content: center;
  grid-column-gap: 1rem;
  grid-row-gap: 0.5rem;
}
::ng-deep .product-collection .product-main-content .grid-product-results .p-card {
  /*box-shadow: none;*/
  background-color: #fff;
  border-radius: 10px;
  color: var(--accent);
  display: flex;
  flex-direction: column;
  height: auto;
  justify-content: space-between;
  max-width: 300px;
  overflow: hidden;
}
::ng-deep .product-collection .product-main-content .grid-product-results .p-card .top-section .product-brand-wrapper {
  align-items: stretch;
  display: flex;
  justify-content: center;
  text-align: center;
  width: 100%;
  height: 50px !important;
}
::ng-deep .product-collection .product-main-content .grid-product-results .p-card .top-section .div-block-24 {
  margin-top: 0;
}
::ng-deep .product-collection .product-main-content .grid-product-results .p-card .top-section .div-block-24 .product-name-wrapper {
  margin-top: 1rem;
}
::ng-deep .product-collection .product-main-content .grid-product-results .p-card .top-section .div-block-24 .product-name-wrapper h6.brand-name {
  color: var(--accent) !important;
  font-weight: 600 !important;
  margin-bottom: 2px;
}
::ng-deep .product-collection .product-main-content .grid-product-results .p-card .top-section .div-block-24 .product-name-wrapper h6.product-name {
  color: var(--primary) !important;
  font-weight: 700 !important;
  font-size: 1.1em !important;
  margin-bottom: 2px;
}
::ng-deep .product-collection .product-main-content .grid-product-results .p-card .top-section .div-block-24 .product-name-wrapper h6.product-sub-category {
  font-size: 0.67em !important;
  color: var(--primary) !important;
}
::ng-deep .product-collection .product-main-content .grid-product-results .p-card .bottom-section .ratings-wrapper {
  background: var(--light-2);
  border-radius: 0.5rem;
  display: flex;
  flex: 1;
  flex-direction: column;
  margin: 0.5rem 0 1rem;
  border: 1px solid var(--gray-4);
}
::ng-deep .product-collection .product-main-content .grid-product-results .p-card .bottom-section .ratings-wrapper .rating {
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid var(--gray-4);
  padding: 0 0.5rem;
}
::ng-deep .product-collection .product-main-content .grid-product-results .p-card .bottom-section .ratings-wrapper .rating:last-child {
  border-bottom: none;
}
::ng-deep .product-collection .product-main-content .grid-product-results .p-card .bottom-section .ratings-wrapper .rating h6.type {
  color: var(--accent) !important;
  font-size: 0.8em !important;
  font-weight: 400 !important;
  margin: 2px 0;
  line-height: 1.55 !important;
}
::ng-deep .product-collection .product-main-content .grid-product-results .p-card .bottom-section .ratings-wrapper .rating .p-rating {
  display: flex;
  flex-direction: row-reverse; /* Reverses the order of stars */
  justify-content: flex-end; /* Aligns stars to the right */
}
::ng-deep .product-collection .product-main-content .grid-product-results .p-card .bottom-section .ratings-wrapper .rating .p-rating .p-rating-icon {
  color: transparent;
}
::ng-deep .product-collection .product-main-content .grid-product-results .p-card .bottom-section .ratings-wrapper .rating .p-rating .p-rating-icon.p-rating-icon-active {
  color: var(--accent);
  font-size: 0.25em !important;
}
::ng-deep .product-collection .product-main-content .grid-product-results .p-card .bottom-section .ratings-wrapper .rating .p-rating .p-rating-icon.p-icon {
  width: 0.75rem;
  height: 0.75rem;
}
::ng-deep .product-collection .product-main-content .grid-product-results .p-card .bottom-section .actions-wrapper button {
  width: 100%;
  margin-bottom: 0.25rem;
}
/* Small devices (portrait phones, less than 576px) */
@media (max-width: 575.98px) {
  ::ng-deep #product-id {
    flex-direction: column;
  }
  ::ng-deep #product-id #left-or-top,
  ::ng-deep #product-id #right-or-bottom {
    padding: 0;
  }
}
/* Medium devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767.98px) {
  ::ng-deep #product-id {
    flex-direction: column;
  }
  ::ng-deep #product-id #left-or-top,
  ::ng-deep #product-id #right-or-bottom {
    padding: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/retail/retail.component.scss"],"names":[],"mappings":"AACC;EACC,aAAA;AAAF;AAGC;EACC,qBAAA;EACA,2BAAA;AADF;AAIC;EACC,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;EACA,OAAA;AAFF;AAKC;EACC,kBAAA;EACA,WAAA;AAHF;AAKE;EACC,WAAA;EACA,kBAAA;EACA,+DAAA;EACA,wBAAA;EACA,4BAAA;EACA,6BAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;AAHH;AAOC;EACC,qBAAA;EACA,mBAAA;AALF;AAOE;EACC,iBAAA;EACA,qBAAA;AALH;AASC;EAAQ,qBAAA;AANT;AAQC;EACC,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,OAAA;AANF;AAQE;EACC,aAAA;EACA,OAAA;EACA,mBAAA;EACA,gBAAA;AANH;AASE;EACC,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,OAAA;EACA,sBAAA;AAPH;AASG;EACC,oBAAA;AAPJ;AAUG;EACC,kBAAA;AARJ;AAcE;EACC,sBAAA;EACA,sBAAA;AAZH;AAcG;EACC,uBAAA;EACA,sCAAA;EACA,cAAA;AAZJ;AAmBG;EACC,mBAAA;AAjBJ;AAoBG;EACC,eAAA;EACA,gBAAA;EACA,oBAAA;AAlBJ;AAqBG;EACC,eAAA;EACA,gBAAA;EACA,oBAAA;AAnBJ;AAuBI;EACC,qBAAA;EACA,4BAAA;AArBL;AAuBK;EACC,mBAAA;AArBN;AA+BM;EACC,uBAAA;EACA,iBAAA;AA7BP;AAwCM;EACC,yBAAA;AAtCP;AA4CK;EACC,4BAAA;AA1CN;AAiDC;EACC,cAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;EACA,mBAAA;EACA,gBAAA;AA/CF;AAiDE;EACC,aAAA;EACA,sBAAA;AA/CH;AAiDG;EACC,YAAA;EACA,uBAAA;AA/CJ;AAmDE;EACC,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AAjDH;AAmDG;EACC,WAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;AAjDJ;AAmDI;EACC,gBAAA;EACA,aAAA;AAjDL;AAmDK;;EAEC,sCAAA;AAjDN;AAmDM;;EACC,aAAA;AAhDP;AAqDM;EACC,YAAA;AAnDP;AAqDO;EACC,aAAA;AAnDR;AAqDQ;EACC,qBAAA;EACA,sBAAA;EACA,iBAAA;AAnDT;AA4DE;EACC,kBAAA;EACA,YAAA;EACA,iBAAA;AA1DH;AA6DE;EACC,WAAA;AA3DH;AA8DE;EACC,aAAA;EACA,mBAAA;EACA,oCAAA;EACA,cAAA;AA5DH;AA8DG;EACC,6BAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AA5DJ;AA8DI;EACC,iBAAA;AA5DL;AA+DI;EACC,0CAAA;AA7DL;AAmEG;EACC,iBAAA;EACA,sBAAA;AAjEJ;AAmEI;EACC,iBAAA;AAjEL;AA0EI;EACC,mBAAA;AAxEL;AA4EG;EACC,uBAAA;EACA,qBAAA;EACA,oBAAA;AA1EJ;AA4EI;EACC,oBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,gBAAA;AA1EL;AA6EM;EACC,oBAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;AA3EP;AA8EM;EACC,aAAA;AA5EP;AA8EO;EACC,gBAAA;AA5ER;AA8EQ;EACC,+BAAA;EACA,2BAAA;EACA,kBAAA;AA5ET;AA8EQ;EACC,gCAAA;EACA,2BAAA;EACA,2BAAA;EACA,kBAAA;AA5ET;AA8EQ;EACC,4BAAA;EACA,gCAAA;AA5ET;AAmFM;EACC,0BAAA;EACA,qBAAA;EACA,aAAA;EACA,OAAA;EACA,sBAAA;EACA,qBAAA;EACA,+BAAA;AAjFP;AAmFO;EACC,aAAA;EACA,OAAA;EACA,mBAAA;EACA,8BAAA;EACA,sCAAA;EACA,iBAAA;AAjFR;AAmFQ;EACC,mBAAA;AAjFT;AAoFQ;EACC,+BAAA;EACA,2BAAA;EACA,2BAAA;EACA,aAAA;EACA,4BAAA;AAlFT;AAqFQ;EACC,aAAA;EACA,2BAAA,EAAA,gCAAA;EACA,yBAAA,EAAA,8BAAA;AAnFT;AAqFS;EACC,kBAAA;AAnFV;AAqFU;EACC,oBAAA;EACA,4BAAA;AAnFX;AAuFS;EACC,cAAA;EACA,eAAA;AArFV;AA4FO;EACC,WAAA;EACA,sBAAA;AA1FR;AA8GA,qDAAA;AACA;EAEE;IACC,sBAAA;EA7GD;EA+GC;;IAEC,UAAA;EA7GF;AACF;AAkHA,oDAAA;AACA;EAEE;IACC,sBAAA;EAjHD;EAmHC;;IAEC,UAAA;EAjHF;AACF","sourcesContent":["::ng-deep {\n\t.p-paginator .p-dropdown {\n\t\tdisplay: none;\n\t}\n\n\t:focus {\n\t\toutline: 0 !important;\n\t\tbox-shadow: none !important;\n\t}\n\n\tdiv.content-layout {\n\t\tdisplay: flex;\n\t\tposition: relative;\n\t\tjustify-content: center;\n\t\tflex-wrap: wrap;\n\t\tflex-direction: row;\n\t\tflex: 1;\n\t}\n\n\tdiv.background {\n\t\tposition: relative;\n\t\twidth: 100%;\n\n\t\t&:before {\n\t\t\tcontent:\"\";\n\t\t\tposition: absolute;\n\t\t\tbackground-image : url('/assets/images/rooftop-solar-grid.jpeg');\n\t\t\tbackground-size: contain;\n\t\t\tbackground-repeat: no-repeat;\n\t\t\tbackground-position: left top;\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tmin-height: 475px;\n\t\t\tz-index: 1;\n\t\t}\n\t}\n\n\tul.disc {\n\t\tlist-style-type: disc;\n\t\tmargin-bottom: 1rem;\n\n\t\tli {\n\t\t\tmargin-left: 2rem;\n\t\t\tmargin-bottom: .5rem;\n\t\t}\n\t}\n\n\t:focus {outline:0 !important;}\n\n\t#product-id {\n\t\tposition: relative;\n\t\tdisplay: flex;\n\t\tflex-direction: row;\n\t\tflex-wrap: nowrap;\n\t\tflex: 1;\n\n\t\t#left-or-top {\n\t\t\tdisplay: flex;\n\t\t\tflex: 1;\n\t\t\tpadding-right: 1rem;\n\t\t\toverflow: hidden;\n\t\t}\n\n\t\t#right-or-bottom {\n\t\t\tdisplay: flex;\n\t\t\tpadding-left: 1rem;\n\t\t\toverflow: hidden;\n\t\t\tflex: 1;\n\t\t\tflex-direction: column;\n\n\t\t\ta.category {\n\t\t\t\tcolor: var(--accent);\n\t\t\t}\n\n\t\t\tp.shallow {\n\t\t\t\tmargin: 0 0 .5rem;\n\t\t\t}\n\t\t}\n\t}\n\n\t#product-container {\n\t\ttable {\n\t\t\tmargin-bottom: 1.25rem;\n\t\t\twidth: 100% !important;\n\n\t\t\ttd, th {\n\t\t\t\tpadding: .33rem .5rem;\n\t\t\t\tborder-bottom: 1px solid var(--gray-4);\n\t\t\t\tfont-size: 1em;\n\t\t\t}\n\t\t}\n\t}\n\n\tdiv {\n\t\t&#overview-div {\n\t\t\tp {\n\t\t\t\tmargin-bottom: 1rem;\n\t\t\t}\n\n\t\t\th3 {\n\t\t\t\tfont-size: 20px;\n\t\t\t\tfont-weight: 400;\n\t\t\t\tcolor: var(--dark-1);\n\t\t\t}\n\n\t\t\th4 {\n\t\t\t\tfont-size: 16px;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tcolor: var(--dark-1);\n\t\t\t}\n\n\t\t\tdiv {\n\t\t\t\tul {\n\t\t\t\t\tlist-style-type: none;\n\t\t\t\t\tmargin-left: 2rem !important;\n\n\t\t\t\t\tli {\n\t\t\t\t\t\tmargin-bottom: 1rem;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t&.product-specs-div {\n\t\t\t.p-datatable {\n\t\t\t\t.p-datatable-thead {\n\t\t\t\t\ttr {\n\t\t\t\t\t\tth {\n\t\t\t\t\t\t\tbackground-color: black;\n\t\t\t\t\t\t\tcolor: whitesmoke;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t&.product-docs-div {\n\t\t\t.p-datatable {\n\t\t\t\t.p-datatable-thead {\n\t\t\t\t\ttr {\n\t\t\t\t\t\tth {\n\t\t\t\t\t\t\tbackground-color: #f5f5f5;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t.p-datatable-tbody {\n\t\t\t\t\ttr > td.right {\n\t\t\t\t\t\ttext-align: right !important;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\tp-galleria {\n\t\tdisplay: block;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tborder: 1px solid var(--gray-3);\n\t\tborder-radius: 1rem;\n\t\toverflow: hidden;\n\n\t\t&.fullscreen {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\n\t\t\t.p-galleria-content {\n\t\t\t\tflex-grow: 1;\n\t\t\t\tjustify-content: center;\n\t\t\t}\n\t\t}\n\n\t\tp-galleriacontent {\n\t\t\tposition: relative;\n\t\t\tdisplay: block;\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tmax-width: 475px;\n\t\t\tmax-height: 580px;\n\t\t\tmargin: 1rem auto;\n\n\t\t\t.p-galleria-thumbnail-wrapper {\n\t\t\t\twidth: 100%;\n\t\t\t\tbackground: #fff;\n\t\t\t\theight: 100px;\n\t\t\t\toverflow: hidden;\n\n\t\t\t\t.p-galleria-thumbnail-container {\n\t\t\t\t\tbackground: #fff;\n\t\t\t\t\theight: 100px;\n\n\t\t\t\t\t.p-galleria-thumbnail-next,\n\t\t\t\t\t.p-galleria-thumbnail-prev {\n\t\t\t\t\t\tcolor: var(--primary-color) !important;\n\n\t\t\t\t\t\t&.p-disabled {\n\t\t\t\t\t\t\topacity: 0.25;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\t\t\t\t\t.p-galleria-thumbnail-items-container {\n\t\t\t\t\t\t.p-galleria-thumbnail-items {\n\t\t\t\t\t\t\theight: 100%;\n\n\t\t\t\t\t\t\t.p-galleria-thumbnail-item {\n\t\t\t\t\t\t\t\tflex: 1 0 20%;\n\n\t\t\t\t\t\t\t\t.p-galleria-thumbnail-item-content {\n\t\t\t\t\t\t\t\t\tmargin-right: 0.25rem;\n\t\t\t\t\t\t\t\t\tborder: 1px solid gray;\n\t\t\t\t\t\t\t\t\tmax-width: 68.2px;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\tp-galleriathumbnails {\n\t\t\tposition: relative;\n\t\t\theight: auto;\n\t\t\tmin-height: 100px;\n\t\t}\n\n\t\t.p-galleria-thumbnail-items-container {\n\t\t\twidth: 100%;\n\t\t}\n\n\t\t.custom-galleria-footer {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tbackground-color: rgba(0, 0, 0, .9);\n\t\t\tcolor: #ffffff;\n\n\t\t\t> button {\n\t\t\t\tbackground-color: transparent;\n\t\t\t\tcolor: #ffffff;\n\t\t\t\tborder: 0 none;\n\t\t\t\tborder-radius: 0;\n\t\t\t\tmargin: .2rem 0;\n\n\t\t\t\t&.fullscreen-button {\n\t\t\t\t\tmargin-left: auto;\n\t\t\t\t}\n\n\t\t\t\t&:hover {\n\t\t\t\t\tbackground-color: rgba(255, 255, 255, 0.1);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.title-container {\n\t\t\t> span {\n\t\t\t\tfont-size: .9rem;\n\t\t\t\tpadding-left: .829rem;\n\n\t\t\t\t&.title {\n\t\t\t\t\tfont-weight: bold;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.product-collection {\n\t\t.product-main-content {\n\t\t\ttable {\n\t\t\t\ttd {\n\t\t\t\t\tborder-bottom: none;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.grid-product-results {\n\t\t\t\tjustify-content: center;\n\t\t\t\tgrid-column-gap: 1rem;\n\t\t\t\tgrid-row-gap: .5rem;\n\n\t\t\t\t.p-card {\n\t\t\t\t\t/*box-shadow: none;*/\n\t\t\t\t\tbackground-color: #fff;\n\t\t\t\t\tborder-radius: 10px;\n\t\t\t\t\tcolor: var(--accent);\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tflex-direction: column;\n\t\t\t\t\theight: auto;\n\t\t\t\t\tjustify-content: space-between;\n\t\t\t\t\tmax-width: 300px;\n\t\t\t\t\toverflow: hidden;\n\n\t\t\t\t\t.top-section {\n\t\t\t\t\t\t.product-brand-wrapper {\n\t\t\t\t\t\t\talign-items: stretch;\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\t\ttext-align: center;\n\t\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\t\theight: 50px !important;\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t.div-block-24 {\n\t\t\t\t\t\t\tmargin-top: 0;\n\n\t\t\t\t\t\t\t.product-name-wrapper {\n\t\t\t\t\t\t\t\tmargin-top: 1rem;\n\n\t\t\t\t\t\t\t\th6.brand-name {\n\t\t\t\t\t\t\t\t\tcolor: var(--accent) !important;\n\t\t\t\t\t\t\t\t\tfont-weight: 600 !important;\n\t\t\t\t\t\t\t\t\tmargin-bottom: 2px;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\th6.product-name {\n\t\t\t\t\t\t\t\t\tcolor: var(--primary) !important;\n\t\t\t\t\t\t\t\t\tfont-weight: 700 !important;\n\t\t\t\t\t\t\t\t\tfont-size: 1.1em !important;\n\t\t\t\t\t\t\t\t\tmargin-bottom: 2px;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\th6.product-sub-category {\n\t\t\t\t\t\t\t\t\tfont-size: .67em !important;\n\t\t\t\t\t\t\t\t\tcolor: var(--primary) !important;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\t\t\t\t\t.bottom-section {\n\t\t\t\t\t\t.ratings-wrapper {\n\t\t\t\t\t\t\tbackground: var(--light-2);\n\t\t\t\t\t\t\tborder-radius: .5rem;\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\tflex: 1;\n\t\t\t\t\t\t\tflex-direction: column;\n\t\t\t\t\t\t\tmargin: .5rem 0 1rem;\n\t\t\t\t\t\t\tborder: 1px solid var(--gray-4);\n\n\t\t\t\t\t\t\t.rating {\n\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\tflex: 1;\n\t\t\t\t\t\t\t\tflex-direction: row;\n\t\t\t\t\t\t\t\tjustify-content: space-between;\n\t\t\t\t\t\t\t\tborder-bottom: 1px solid var(--gray-4);\n\t\t\t\t\t\t\t\tpadding: 0 .5rem;\n\n\t\t\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\t\t\tborder-bottom: none;\n\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\th6.type {\n\t\t\t\t\t\t\t\t\tcolor: var(--accent) !important;\n\t\t\t\t\t\t\t\t\tfont-size: .8em !important;\n\t\t\t\t\t\t\t\t\tfont-weight: 400 !important;\n\t\t\t\t\t\t\t\t\tmargin: 2px 0;\n\t\t\t\t\t\t\t\t\tline-height: 1.55 !important;\n\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t.p-rating {\n\t\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\t\tflex-direction: row-reverse; /* Reverses the order of stars */\n\t\t\t\t\t\t\t\t\tjustify-content: flex-end; /* Aligns stars to the right */\n\n\t\t\t\t\t\t\t\t\t.p-rating-icon {\n\t\t\t\t\t\t\t\t\t\tcolor: transparent;\n\n\t\t\t\t\t\t\t\t\t\t&.p-rating-icon-active {\n\t\t\t\t\t\t\t\t\t\t\tcolor: var(--accent);\n\t\t\t\t\t\t\t\t\t\t\tfont-size: .25em !important;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t.p-rating-icon.p-icon {\n\t\t\t\t\t\t\t\t\t\twidth: .75rem;\n\t\t\t\t\t\t\t\t\t\theight: .75rem;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t.actions-wrapper {\n\t\t\t\t\t\t\tbutton {\n\t\t\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\t\t\tmargin-bottom: .25rem;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&.inverters-main-content {\n\t\t\t\tp-table {\n\t\t\t\t\ttr {\n\t\t\t\t\t\ttd {\n\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n/* Small devices (portrait phones, less than 576px) */\n@media (max-width: 575.98px) {\n\t::ng-deep {\n\t\t#product-id {\n\t\t\tflex-direction: column;\n\n\t\t\t#left-or-top,\n\t\t\t#right-or-bottom {\n\t\t\t\tpadding: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/* Medium devices (landscape phones, 576px and up) */\n@media (min-width: 576px) and (max-width: 767.98px) {\n\t::ng-deep {\n\t\t#product-id {\n\t\t\tflex-direction: column;\n\n\t\t\t#left-or-top,\n\t\t\t#right-or-bottom {\n\t\t\t\tpadding: 0;\n\t\t\t}\n\t\t}\n\t}\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
